import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';

import { QueueIdEnum, SortTypesEnum, TaskListModeEnum } from '../shared/enums';
import { SortType } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root',
})
export class SortService {
  private sortId: { [key: string]: number } = {};
  private readonly _sortDisabledQueueIds = [
    QueueIdEnum.AnsweredByMe,
    QueueIdEnum.ArchivedByMe,
    QueueIdEnum.AnsweredByOthers,
    QueueIdEnum.ArchivedByOthers,
  ];
  sortTypeMap: Map<number, SortType[]> = new Map();

  get sortDisabledQueueIds() {
    return this._sortDisabledQueueIds;
  }

  constructor(private alcmeonContextService: AlcmeonContextService, private storage: Storage) {}

  getStorageKey(taskListMode: TaskListModeEnum) {
    return `${taskListMode}-sort-${this.alcmeonContextService.companyId}`;
  }

  setSortId(sortId: number, taskListMode: TaskListModeEnum) {
    this.sortId[taskListMode] = sortId;
  }

  getSortTypes(): SortType[] {
    const user = this.alcmeonContextService.self;
    if (!user) {
      return [];
    }
    return user.companies[0].sort_types || [];
  }

  /**
   * Get current sortId, or get it from storage and check if it's valid
   */
  async getSortId(taskListMode: TaskListModeEnum, queueId?: QueueIdEnum): Promise<number> {
    if (this.sortDisabledQueueIds.includes(queueId)) {
      return SortTypesEnum.mostRecentMessageFirst;
    }

    if (this.sortId[taskListMode] || this.sortId[taskListMode] === 0) {
      return this.sortId[taskListMode];
    }

    const sortTypes = this.getSortTypes();
    if (sortTypes.length > 0) {
      const storageSortId = await this.storage.get(this.getStorageKey(taskListMode));

      // Check that saved sort id exists in sort types list
      if (storageSortId !== null && sortTypes.filter(sortType => sortType.id === storageSortId).length > 0) {
        this.sortId[taskListMode] = storageSortId;
      } else {
        this.sortId[taskListMode] = sortTypes[0].id;
        this.storage.remove(this.getStorageKey(taskListMode));
      }
    }

    return this.sortId[taskListMode];
  }
}
